































































import Vue from 'vue'
import store from '@/store'
import { WorksItem, formatWorksItem, getWorksImageSrc } from '@/types/works'

const WP_SITE_URL = process.env.NODE_ENV === 'development'
  ? process.env.VUE_APP_DEV_WP_SITE_URL
  : process.env.VUE_APP_PRO_WP_SITE_URL

export default Vue.extend({
  data() {
    return {
      work: null as WorksItem | null,
      relatedWorks: [] as WorksItem[],
      loading: true
    }
  },

  async created() {
    await this.fetchWork()
  },

  watch: {
    '$route': 'fetchWork'
  },

  methods: {
    getImageSrc(image: any): string {
      return getWorksImageSrc(image)
    },

    async fetchWork() {
      this.loading = true
      const id = this.$route.params.id

      try {
        const query = new URLSearchParams({
          _embed: '1',
          acf_format: 'standard'
        })

        const response = await fetch(`${WP_SITE_URL}/wp-json/wp/v2/works/${id}?${query}`)
        const post = await response.json()
        this.work = formatWorksItem(post)

        if (this.work.tags.length) {
          await this.fetchRelatedWorks(this.work.tags[0].id, this.work.id)
        }
      } catch (error) {
        console.error(error)
        this.work = null
      } finally {
        this.loading = false
      }
    },

    async fetchRelatedWorks(tagId: number, excludeId: number) {
      const query = new URLSearchParams({
        per_page: '4',
        tags: String(tagId),
        exclude: String(excludeId),
        _embed: '1',
        acf_format: 'standard'
      })

      try {
        const response = await fetch(`${WP_SITE_URL}/wp-json/wp/v2/works?${query}`)
        const posts = await response.json()
        this.relatedWorks = posts.map((post: any) => formatWorksItem(post))
      } catch (error) {
        console.error(error)
        this.relatedWorks = []
      }
    }
  }
})
